import { Box, Container, Heading } from "@chakra-ui/react";
import fs from "fs";
import { MDXLayoutRenderer } from "@/components/blog/MDXLayoutRenderer";
import Navbar from "@/components/Navbar";
import generateRss from "@/utils/blog/generate-rss";
import { formatSlug, getAllFilesFrontMatter, getFileBySlug, getFiles } from "@/utils/blog/mdx";
import Footer from "@/components/Footer";
import { createCheckeredBackground } from "@/utils/style";
import { getTopNProfiles } from "@/utils/algolia-init";
import Head from "next/head";
import { withUserData } from "@/contexts/UserDataContext";

const DEFAULT_LAYOUT = "PostLayout";

export async function getStaticPaths() {
  const posts = getFiles("blog");
  const isBuildingLocally = !process.env.VERCEL_ENV && !process.env.BUILDING_SITEMAP;
  return {
    paths: posts.slice(0, isBuildingLocally ? 0 : undefined).map((p) => ({
      params: {
        slug: formatSlug(p).split("/"),
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const allPosts = await getAllFilesFrontMatter("blog");
  const postIndex = allPosts.findIndex((post) => formatSlug(post.slug) === params.slug.join("/"));
  const prev = allPosts[postIndex + 1] || null;
  const next = allPosts[postIndex - 1] || null;
  const post = await getFileBySlug("blog", params.slug.join("/"));
  const authorList = post.frontMatter.authors || ["default"];
  const authorPromise = authorList.map(async (author) => {
    const authorResults = await getFileBySlug("authors", [author]);
    return authorResults.frontMatter;
  });
  const authorDetails = await Promise.all(authorPromise);

  // rss
  if (allPosts.length > 0) {
    const rss = generateRss(allPosts);
    fs.writeFileSync("./public/feed.xml", rss);
  }

  const previewProfiles = await getTopNProfiles(20);

  return { props: { post, authorDetails, prev, next, previewProfiles } };
}

function Blog({ post, authorDetails, prev, next, previewProfiles }) {
  const { mdxSource, toc, frontMatter } = post;
  const bg = createCheckeredBackground("0.5rem", "#cccccc", "22", "transparent");
  return (
    <>
      <Head>
        {/* Install the Google Fonts "Gloock" font */}
        {/* <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link href="https://fonts.googleapis.com/css2?family=Gloock&display=swap" rel="stylesheet" /> */}
      </Head>
      <Box bg="gray.50" pb={150}>
        <Navbar />
        <Container maxW="container.xl">
          {frontMatter.draft !== true ? (
            <MDXLayoutRenderer
              previewProfiles={previewProfiles}
              layout={frontMatter.layout || DEFAULT_LAYOUT}
              toc={toc}
              mdxSource={mdxSource}
              frontMatter={frontMatter}
              authorDetails={authorDetails}
              prev={prev}
              next={next}
            />
          ) : (
            <Heading as="h1" textAlign="center">
              Under Construction
            </Heading>
          )}
        </Container>
      </Box>

      <Box marginTop={{ base: -100, md: -150 }}>
        <Footer />
      </Box>
    </>
  );
}

export default withUserData(Blog);
